/* bomb.icon.svg.js */

"use strict";
module.exports = {
    icon: `
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
			<path class="foreground-gl"  d="M5.3,3.4c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7C10.7,3.7,11,4,11.4,4C11.7,4,12,3.7,12,3.4V2.7h1.3v0.6
				c0,1-0.8,1.9-1.9,1.9l0,0c-1,0-1.9-0.8-1.9-1.9c0-0.8-0.7-1.5-1.5-1.5S6.5,2.6,6.5,3.4h1.1v1.1c2.4,0.7,4.2,3,4.2,5.7
				c0,3.3-2.6,5.9-5.9,5.9S0,13.4,0,10.1c0-2.7,1.8-4.9,4.2-5.7V3.4H5.3 M14.3,3.4H16v0.8h-1.7V3.4 M11.8,1.7V0h0.8v1.7H11.8 M13.4,2
				l1.2-1.2l0.6,0.6L14,2.6L13.4,2z"/>
			</svg>
        `,
};
